import styles from "../styles/RegisterForm2.module.scss";
import { registerUseCase } from "../../lib/dependencies";
import React, { useState } from "react";
import { useRouter } from "next/router";
import { route } from "next/dist/next-server/server/router";

export default function RegisterForm2({
  email,
  username,
}: {
  email: string;
  username: string;
}) {
  const [verifyCode, setVerifyCode] = useState("");
  const [verificationCodeSent, setVerificationCodeSent] = useState(false);
  const router = useRouter();

  function handleVerifyCode(event) {
    setVerifyCode(event.target.value);
  }

  async function sendVerificationCode(username) {
    const response = await registerUseCase.sendVerificationCode(username);
    setVerificationCodeSent(!verificationCodeSent);
    if (response.error) {
      return window.alert(JSON.stringify(response));
    }
  }

  async function verifyAccount(username, verificationCode) {
    const response = await registerUseCase.verifyAccount(
      username,
      verificationCode
    );
    if (response.error) {
      return window.alert(JSON.stringify(response));
    }
    router.push("/login");
  }

  return (
    <div className={styles.form_container}>
      <div className={styles.text}>Account verification</div>
      <div className={styles.smaller_dark_blue_text}>
        Send verification code to your email address
        <div className={styles.yellow_text}>({email})</div>
      </div>
      <button
        disabled={verificationCodeSent}
        className={styles.yellow_button}
        onClick={() => sendVerificationCode(username)}
      >
        Send
      </button>
      <div className={styles.text}>Code from the e-mail</div>
      <input className={styles.input_dialog} onChange={handleVerifyCode} />
      <button
        className={styles.yellow_button}
        onClick={() => verifyAccount(username, verifyCode)}
      >
        Submit
      </button>
    </div>
  );
}
